package app.footyguide.web.components.club

import app.footyguide.core.locale.AppStrings
import app.footyguide.core.locale.Strings
import app.footyguide.core.locale.UiLanguage
import app.footyguide.core.theme.ClubCatalog
import app.footyguide.domain.model.Game

enum class ClubSubTab(val label: String) {
    OVERVIEW("Visão Geral"),
    CALENDAR("Calendário"),
    STANDINGS("Tabela");

    fun getDisplay(strings: AppStrings): String = when (this) {
        OVERVIEW -> strings.overview
        CALENDAR -> strings.calendar
        STANDINGS -> strings.standings
    }
}

fun resolveMatchResultBadge(
    game: Game,
    myTeamId: String,
    strings: AppStrings = Strings.forLanguage(UiLanguage.PT),
): String {
    val canonicalMyId = ClubCatalog.bySlug(myTeamId)?.slug ?: myTeamId
    val canonicalHomeId = ClubCatalog.bySlug(game.homeTeamId)?.slug ?: game.homeTeamId
    val isHome = canonicalHomeId == canonicalMyId
    val myScore = if (isHome) (game.homeScore ?: 0) else (game.awayScore ?: 0)
    val oppScore = if (isHome) (game.awayScore ?: 0) else (game.homeScore ?: 0)

    val letter = when {
        myScore > oppScore -> strings.resultWinShort
        myScore < oppScore -> strings.resultLossShort
        else -> strings.resultDrawShort
    }
    return "$letter $myScore - $oppScore"
}

fun resolveResultBadgeColor(
    badge: String,
    strings: AppStrings = Strings.forLanguage(UiLanguage.PT),
): Pair<String, String> {
    val token = badge.substringBefore(" ").trim()
    return when (token) {
        strings.resultWinShort -> Pair("#ECFDF5", "#059669")
        strings.resultLossShort -> Pair("#FEF2F2", "#DC2626")
        strings.resultDrawShort -> Pair("#F4F4F5", "#71717A")
        "V", "W" -> Pair("#ECFDF5", "#059669")
        "L" -> Pair("#FEF2F2", "#DC2626")
        else -> Pair("#F4F4F5", "#71717A")
    }
}
